import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "../Qiymat/Kard.css";

function Kard({ kurslar, turi, setKurs_id }) {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [scrollLeft, setScrollLeft] = React.useState(0);
  const [hasMoved, setHasMoved] = React.useState(false);

  const handleCardClick = (id) => {
    if (!hasMoved) {
      setKurs_id(id);
      navigate("/web");
    }
  };

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    setHasMoved(false);
  };

  const stopDragging = () => {
    setIsDragging(false);
  };

  const onDrag = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2; // scroll-fast
    scrollRef.current.scrollLeft = scrollLeft - walk;
    if (Math.abs(walk) > 5) setHasMoved(true);
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const kardlar = kurslar
    .filter((kurs) => kurs.turi === turi)
    .map((kurs) => {
      const isReady =
        (kurs.id >= 7 && kurs.id <= 12) || (kurs.id >= 19 && kurs.id <= 23);
      return (
        <div
          className={"kard-icon" + (isReady ? " tayyor" : "")}
          key={kurs.id}
          onClick={() => handleCardClick(kurs.id)}
        >
          <img src={kurs.rasm} alt={kurs.nomi} />
          <span>{kurs.nomi}</span>
        </div>
      );
    });

  return (
    <div className="slider-outer-wrapper">
      <div className="slider-container">
        <button className="slider-button left" onClick={() => scroll("left")}>
          <FaChevronLeft />
        </button>
        <div
          className={`kard-quti ${isDragging ? "active" : ""}`}
          ref={scrollRef}
          onMouseDown={startDragging}
          onMouseLeave={stopDragging}
          onMouseUp={stopDragging}
          onMouseMove={onDrag}
        >
          {kardlar}
        </div>
        <button className="slider-button right" onClick={() => scroll("right")}>
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
}

export default Kard;
